import React from 'react';

import { Label } from './label';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  description?: string;
  error?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(({ label, ...props }, ref) => {
  const { className, ...rest } = props;

  return (
    <div className={className}>
      <input className='mr-2' ref={ref} type='checkbox' {...rest} />
      <Label htmlFor={props.name}>{label}</Label>
    </div>
  );
});

Checkbox.displayName = 'Checkbox';
